<template>
  <fieldset>
    <SignupLegend title="Congratulations!"/>
    <h3>Your registration with aio* is complete! <br>
      <small>You will receive an email with further instructions.</small>
    </h3>
    <hr>
    <h4>You can access <a :href="appURL" target="_blank">aio* online</a> or download the app</h4>
    <div class="row text-center">
      <div class="col-sm-4"><a :href="appURL" target="_blank"><h3>{{appLink}}</h3></a></div>
      <div class="col-sm-4"><a :href="iosURL" target="_blank"><h3><img src="@/assets/ios.png"></h3></a></div>
      <div class="col-sm-4"><a :href="androidURL" target="_blank"><h3><img src="@/assets/android.png"></h3></a></div>
    </div>
  </fieldset>
</template>

<script>
  import SignupLegend from '@/components/SignupLegend'

  export default {
    components: {
      SignupLegend
    },
    computed: {
      appLink () {
        return this.appURL.replace(/.*?:\/\//g, '')
      }
    },
    data () {
      return {
        appURL: 'https://app.getaio.co.uk',
        androidURL: 'https://play.google.com/store/apps/details?id=com.levima.app&hl=en_GB',
        iosURL: 'https://itunes.apple.com/gb/app/levima/id1149425653?mt=8'
      }
    },
    mounted () {
      localStorage.removeItem('currentIndex')
      localStorage.removeItem('formData')
      localStorage.removeItem('regToken')
    }
  }
</script>

<style lang="scss" scoped>
  h4 {
    margin-bottom: 60px;
  }
</style>
